import { render, staticRenderFns } from "./OverlaySelforderingQR.vue?vue&type=template&id=6cddb198&"
import script from "./OverlaySelforderingQR.vue?vue&type=script&lang=js&"
export * from "./OverlaySelforderingQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cddb198')) {
      api.createRecord('6cddb198', component.options)
    } else {
      api.reload('6cddb198', component.options)
    }
    module.hot.accept("./OverlaySelforderingQR.vue?vue&type=template&id=6cddb198&", function () {
      api.rerender('6cddb198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/OverlaySelforderingQR.vue"
export default component.exports